import React, { useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "./ProjectCard.css";
import "twin.macro";

const ProjectCard = (data) => {
  const { title, image } = data;
  const img = getImage(image);
  const [cardVisibility, setCardVisibility] = useState("hidden");

  const handleMouseEnter = () => {
    setCardVisibility("visible");
  };
  const handleMouseOut = () => {
    setCardVisibility("hidden");
  };

  return (
    <li class="cards_item">
      <div
        aria-hidden="true"
        className="card"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseOut}
      >
        <div className="card_image">
          <GatsbyImage
            tw="rounded-2xl h-auto w-full shadow-2xl group-hover:(px-0!)"
            image={img}
            alt="profile"
          />
        </div>
        <button
          className="btn card_btn"
          style={{ visibility: `${cardVisibility}`, transition: "ease-in-out" }}
        >
          {/* <a href="/">View Project</a> */}
        </button>
      </div>
    </li>
  );
};

export default ProjectCard;
